import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useModal } from '../../utils/useModal';
import { DeleteAiModal } from '../../DeleteAiModal';

// Board, My Work and menu cleanup once an Action is gone; shared with the federated dialog's delete.
export function processActionItemDeleted(aiId: string) {
  const channel = new BroadcastChannel('ai:actionItemDeleted');
  channel.postMessage(aiId);
  window.backendLoadAfterSaveWithTimeOut?.(aiId);
  window.processPostDelete(aiId, aiFullViewPopUp.data('obj'));
}

export function useDeleteModal(aiId: string, onComplete: () => void) {
  const { isPermitted, actionItem } = useActionItem(aiId);
  const canDelete = isPermitted(Operation.delete);
  const title = actionItem?.typeAttributes?.label ?? 'Action';
  const handleComplete = () => {
    onComplete();
    processActionItemDeleted(aiId);
  };

  const { show: showDeleteAiModal } = useModal(DeleteAiModal, {
    aiId,
    onComplete: () => handleComplete(),
    title,
  });

  return [canDelete, showDeleteAiModal, title] as const;
}
